import { NAME } from "./constants"

export const LOADING_ORGS = `${NAME}/LOADING_ORGS`
export const RECEIVED_ORGS = `${NAME}/RECEIVED_ORGS`
